import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceExclusionReason, EXCLUSION_REASON_OPTIONS } from '../../../models/devicestatus.model';

@Component({
  selector: 'app-add-exclusion-dialog',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [MatDialogModule, MatButtonModule, MatSelectModule, MatFormFieldModule, FormsModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ 'ADD_EXCLUSION' | translate }}</h2>
    <mat-dialog-content>
      <p>{{ 'ADD_EXCLUSION_CONFIRM' | translate : { name: data.deviceName || data.deviceId } }}</p>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'EXCLUSION_REASON' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedReason">
          @for (option of reasonOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.key | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <p class="text-muted small mb-0">{{ 'EXCLUSION_INFO_TEXT' | translate }}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="ml-3 mb-3">
      <button class="btn btn-primary mr-2" (click)="confirm()" [disabled]="selectedReason === null">{{ 'CONFIRM' | translate }}</button>
      <button class="btn btn-outline-dark" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </mat-dialog-actions>
  `
})
export class AddExclusionDialogComponent {
  selectedReason: DeviceExclusionReason | null = null;

  readonly reasonOptions = EXCLUSION_REASON_OPTIONS;

  constructor(
    private dialogRef: MatDialogRef<AddExclusionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deviceId: string; deviceName?: string }
  ) {}

  confirm(): void {
    this.dialogRef.close(this.selectedReason);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
